import { ORDER_METHODS, RoomServiceLocationType } from '../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'room service',
      [RoomServiceLocationType.TableService]: 'table service',
    },
    [ORDER_METHODS.PICKUP]: 'pickup',
    [ORDER_METHODS.DELIVERY]: 'delivery',
  },
  errors: {
    draft_validation_failed: 'Please complete your delivery address before continuing.',
  },
};
